import React from 'react';
import { map, isEqual, find, head, isUndefined } from 'lodash';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';

// import { AddEditHealthConditions } from 'ui/containers/AddEditHealthConditions';
import {  AddEditAllergies  } from 'ui/containers/AddEditAllergies';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { editHealthInfoHealthConditions as EditHealthInfoHealthConditions } from 'ui/views/widgets/editHealthInfoHealthConditions';
 *
 * // render
 * <EditHealthInfoHealthConditions propName='propValue'/>
 */
export const editHealthInfoHealthConditions = ( props ) => {
    const others = find( props.sections, { name: 'others' }, {} );
    const othersFieldPlaceHolder = !isUndefined(others) && head( others.fields ).placeholder;
    const searchAndAddHealthConditions = find( props.sections, { name: 'searchAndAddHealthConditions' }, {} );
    const noDataConfig = find( props.sections, { name: 'noData' }, {} );
   console.log(props)
    return (
        <div className='ui-edit-health-info-health-conditions'>
            <div className='ui-edit-health-info-health-conditions__header'>

                {/* title for the modal */}
                <div className='ui-edit-health-info-health-conditions__header__title'>
                    { getLabel( props.widgetConfig.title ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>
            <div className='ui-edit-health-info-health-conditions__body'>

                <AddEditAllergies
                    notePlaceHolder = { othersFieldPlaceHolder }
                    items = { props.healthConditions }
                    addEditMemberHealthConfig = { searchAndAddHealthConditions }
                    onUpdate = { props.onUpdate }
                    selectionCriteria= { 'name' }
                    noDataConfig={ noDataConfig }
                    finalProp= {  props.finalprop }
                    healthVisibility = {props.visibility}
                    titlehealth={ 'HealthCondition' }
                />

                {/* actions : Cancel and Save */}
                <div className='ui-edit-health-info-health-conditions__body__actions'>
                    {
                        map( props.action, ( action ) => {
                            return (
                                <Button
                                    key={ action.name }
                                    id= { action.name }
                                    { ...action }
                                    outline={ 'cancel' === action.name ? true: false }
                                    size='large'
                                    className='ui-edit-health-info-health-conditions__body__actions__action'
                                    onClick = { isEqual( 'cancel', action.name ) ?  () => props.onCancelClick() : () => props.onSumbitClick() }
                                />
                            );
                        } )
                    }
                </div>
            </div>
        </div>
    );
};

// set display name
editHealthInfoHealthConditions.displayName = 'editHealthInfoHealthConditions';

// set default props
editHealthInfoHealthConditions.defaultProps = {};

// prop types
editHealthInfoHealthConditions.propTypes = {};
